<template>
    <span 
        class="text-primary"
        v-if="permiteDetalharDespesa"
    >    
        <i
            class="fa fa-info-circle fa-lg icon-button"
            title="Detalhar"
            @click.stop="detalharDespesa()"
        ></i>
    </span>
</template>

<script>

export default {
    props: {
        despesaId: {
            type: String,
            default: () => null
        },

        rotaDespesa: {
            type: String,
            default: () => null
        },

        temAcessoDetalharDespesa: {
            type: Boolean,
            default: () => false
        }
    },

    methods: {
        detalharDespesa() {
            // let routeData = this.$router.resolve({
            //     name: this.rotaDespesa,
            //     params: {
            //         despesaId: this.despesaId
            //     }
            // })
            // window.open(routeData.href, '_blank')
            this.$router.push({
                name: this.rotaDespesa,
                params: {
                    despesaId: this.despesaId
                }
            })
        },
    },

    computed: {
        permiteDetalharDespesa() {
            return this.rotaDespesa != null
                && this.temAcessoDetalharDespesa
                && this.despesaId != null
        }
    }
}
</script>